import { render, staticRenderFns } from "./DepositsStatsTables.component.vue?vue&type=template&id=938bdb98&scoped=true&"
import script from "./DepositsStatsTables.component.vue?vue&type=script&lang=js&"
export * from "./DepositsStatsTables.component.vue?vue&type=script&lang=js&"
import style0 from "./DepositsStatsTables.component.vue?vue&type=style&index=0&id=938bdb98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938bdb98",
  null
  
)

export default component.exports